import { useContext } from 'react'
import { PartnerContext } from '../providers/partnerProvider'

export const usePartnerDetails = () => {
  const context = useContext(PartnerContext)

  if (!context || !context.setPartnerDetails) {
    throw new Error('usePartnerDetails must be used within a PartnerProvider')
  }

  const { partnerDetails, setPartnerDetails } = context

  return {
    partnerDetails,
    setPartnerDetails
  }
}
